import { Animation } from './Animation';
import jQuery from 'jquery';
export function transition(effect, _ = {}) {
    return new Animation(effect);
}
export const makeBlock = (el) => ({
    animation: transition({
        el,
        state: 'open',
        stateAttribute: 'data-accordion-state',
        stateChangeAttribute: 'data-accordion-animation',
    }),
    isOpen: true,
});
export const setOpenHeight = (el) => {
    el.style.setProperty('--menu-open-height', `${el.scrollHeight}px`);
};
export function focusable(container) {
    var elements = Array.prototype.slice.call(container.querySelectorAll('[tabindex],' +
        '[draggable],' +
        'a[href],' +
        'area,' +
        'button:enabled,' +
        'input:not([type=hidden]):enabled,' +
        'object,' +
        'select:enabled,' +
        'textarea:enabled'));
    // Filter out elements that are not visible.
    // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
    return elements.filter(function (element) {
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
}
/**
 * Traps the focus in a particular container
 *
 * @param {Element} container - Container DOM element to trap focus inside of
 * @param {Element} elementToFocus - Element to be focused on first
 * @param {Object} options - Settings unique to your theme
 * @param {string} options.className - Class name to apply to element on focus.
 */
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 */
/**
 * Moves focus to an HTML element
 * eg for In-page links, after scroll, focus shifts to content area so that
 * next `tab` is where user expects. Used in bindInPageLinks()
 * eg move focus to a modal that is opened. Used in trapFocus()
 *
 * @param {Element} container - Container DOM element to trap focus inside of
 * @param {Object} options - Settings unique to your theme
 * @param {string} options.className - Class name to apply to element on focus.
 */
export function forceFocus(element, options) {
    options = options || {};
    var savedTabIndex = element.tabIndex;
    element.tabIndex = -1;
    element.dataset.tabIndex = savedTabIndex;
    element.focus();
    if (typeof options.className !== 'undefined') {
        element.classList.add(options.className);
    }
    element.addEventListener('blur', callback);
    function callback(event) {
        event.target.removeEventListener(event.type, callback);
        element.tabIndex = savedTabIndex;
        delete element.dataset.tabIndex;
        if (typeof options.className !== 'undefined') {
            element.classList.remove(options.className);
        }
    }
}
var trapFocusHandlers = {
    focusin: (event) => { },
    focusout: (event) => { },
    keydown: (event) => { },
};
export function trapFocus(container, options) {
    options = options || {};
    var elements = focusable(container);
    var elementToFocus = options.elementToFocus || container;
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
            first.focus();
        }
        if (event.target !== container && event.target !== last && event.target !== first)
            return;
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9)
            return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }
        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    forceFocus(elementToFocus, options);
}
/**
 * Removes the trap of focus from the page
 */
export function removeTrapFocus(_) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
}
export const adjustHeight = (block) => {
    var _a, _b, _c;
    const $block = jQuery(block);
    const $wrapper = $block.find('.promo-block--content-wrapper');
    const padding = window.getComputedStyle($block[0], null).getPropertyValue('padding-top').replace('px', '');
    if (((_a = $block === null || $block === void 0 ? void 0 : $block.innerHeight()) !== null && _a !== void 0 ? _a : 0) - Number(padding) * 2 < ((_b = $wrapper === null || $wrapper === void 0 ? void 0 : $wrapper.innerHeight()) !== null && _b !== void 0 ? _b : 0)) {
        $block.css({
            height: `${((_c = $wrapper === null || $wrapper === void 0 ? void 0 : $wrapper.innerHeight()) !== null && _c !== void 0 ? _c : 0) + Number(padding) * 2}px`,
        });
        $wrapper.css({
            transform: 'none',
            top: 'auto',
        });
    }
}; // Removes height settings on the block because they only need to be there for small screens
export const resetHeight = (block) => {
    const $block = jQuery(block);
    const $wrapper = $block.find('.promo-block--content-wrapper');
    $block.css({
        height: '',
    });
    $wrapper.css({
        transform: '',
        top: '',
    });
};
